import {useParams} from 'next/navigation'
import {useRouter} from 'next/router'

import {getContentsBannerQuery} from '$queries/insurance/contentQuery'
import {insuranceQueryParser} from '$utils/insurance'

import useWebAppApiQuery from '../useWebAppApiQuery'

export const useContentsBanner = () => {
    const router = useRouter()

    const {id} = useParams<{id: string}>()

    const params = insuranceQueryParser(router.query)

    const {data} = useWebAppApiQuery({
        ...getContentsBannerQuery.query({
            params: {...params, contentId: +id},
        }),
    })

    return data
}
